import React from 'react';
import styled from 'styled-components/macro';
import { NumericStepperProps } from '../types/NumericStepperProps';

const UnstyledNumericStepper: React.FC<NumericStepperProps> = ({
  className,
  value,
  step,
  onIncrement,
  onDecrement,
  singleItemDescriptor,
  pluralItemDescriptor,
}) => {
  const stepAmt = step || 1;
  return (
    <div
      className={'ww-numeric-stepper ' + className}
      aria-label={'Decrease by ' + (step || 1)}
    >
      <button onClick={() => onDecrement(value - stepAmt)}>
        {(step && step !== 1 && <span>-{step}</span>) || (
          <i className="icon-minus" />
        )}
      </button>
      <div className="display">
        <div className="value">{value}</div>
        {singleItemDescriptor && pluralItemDescriptor && (
          <div className="descriptor">
            {value === 1 ? singleItemDescriptor : pluralItemDescriptor}
          </div>
        )}
      </div>
      <button
        onClick={() => onIncrement(value + stepAmt)}
        aria-label={'Increase by ' + (step || 1)}
      >
        {(step && step !== 1 && <span>+{step}</span>) || (
          <i className="icon-plus" />
        )}
      </button>
    </div>
  );
};

const NumericStepper = styled(UnstyledNumericStepper)`
  display: flex;
  flex-direction: row;

  button {
    appearance: none;
    outline: none;
    border: 1px solid var(--secondary-color);
    background-color: var(--secondary-color);
    width: 2.462em;
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    flex: none;
    color: var(--white);
    font-weight: 600;
    cursor: pointer;
    font-size: inherit;
    border-radius: 0;
    padding: 0;
    text-decoration: none;
  }

  .display {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    border-top: 1px solid var(--gray-3);
    border-bottom: 1px solid var(--gray-3);
    width: 3.846em;
    line-height: normal;
    min-height: 2.9em;
  }

  .display .descriptor {
    font-size: 0.9em;
    color: var(--gray-6, #888888);
  }
`;

export default NumericStepper;
